import { render, staticRenderFns } from "./ImpressumText.vue?vue&type=template&id=ff936a36&scoped=true&"
import script from "./ImpressumText.vue?vue&type=script&lang=js&"
export * from "./ImpressumText.vue?vue&type=script&lang=js&"
import style0 from "./ImpressumText.vue?vue&type=style&index=0&id=ff936a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff936a36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
